import { blockAdapterBase } from 'volto-ministerio-publico-federal/helpers/BlockAdapter/BlockAdapter';
import { ONDE_ATUA_CARD_FIELDS } from './schema';

interface PageBrain {
  Title?: string;
  [key: string]: unknown;
}

interface CardItem {
  title?: string;
  [key: string]: unknown;
}

/**
 * Ao escolher o conteúdo no campo Conteúdo, herda o título como legenda.
 * Só preenche quando a legenda está vazia (ver `Destaques/adapter.ts`).
 */
export const buildCardFields = (
  page: PageBrain,
  item: CardItem = {},
): Partial<CardItem> =>
  !item.title && page.Title ? { title: page.Title } : {};

/**
 * Autofill das três listas de cards.
 *
 * `blockAdapterBase` só sabe cuidar de UMA lista por vez (ela compara
 * `id === dictId`), então aqui o campo alterado escolhe a lista. Os demais
 * campos do bloco — rótulo da aba, texto, botão — caem no gravar direto, sem
 * o qual nada além dos cards seria salvo.
 */
export const OndeAtuaBlockDataAdapter = ({
  block,
  data,
  id,
  onChangeBlock,
  value,
}: {
  block: string;
  data: Record<string, unknown>;
  id: string;
  onChangeBlock: (block: string, data: unknown) => void;
  value: unknown;
}) => {
  if (ONDE_ATUA_CARD_FIELDS.includes(id)) {
    blockAdapterBase(
      block,
      data,
      id,
      onChangeBlock,
      value,
      id,
      buildCardFields,
    );
    return;
  }
  onChangeBlock(block, { ...data, [id]: value });
};

export default OndeAtuaBlockDataAdapter;
